import type { FC } from 'react';
import { Flex } from '@ui';
import { AirportsSection } from '@/pages/index/components/AirportsSection/AirportsSection';
import { BookingsEventsSection } from '@/pages/index/components/BookingsEventsSection/BookingsEventsSection';
import { ControllersMapSection } from '@/pages/index/components/ControllersMapSection/ControllersMapSection';
import { FeedbackSection } from '@/pages/index/components/FeedbackSection/FeedbackSection';
import { MailsSection } from '@/pages/index/components/MailsSection/MailsSection';
import { TowerStatsSection } from '@/pages/index/components/TowerStatsSection/TowerStatsSection';
import { TrainingSection } from '@/pages/index/components/TrainingSection/TrainingSection';
import styles from './IndexPage.module.css';

export const Page: FC = () => (
    <Flex vertical className={styles.page} flex="1 0">
        <div className={styles.primaryBackground}>
            <TowerStatsSection />
        </div>
        <div className={styles.halfBackground}>
            <ControllersMapSection />
        </div>
        <div className={styles.secondaryBackground} style={{ scrollMarginTop: 64 }} id="events">
            <BookingsEventsSection />
        </div>
        <div className={styles.secondaryBackground} style={{ scrollMarginTop: 48 }} id="airports">
            <AirportsSection />
        </div>
        <div className={styles.primaryBackground} style={{ scrollMarginTop: 48 }} id="contacts">
            <FeedbackSection />
        </div>
        <div className={styles.primaryBackground}>
            <MailsSection />
        </div>
        <div className={styles.halfBackgroundFooter}>
            <TrainingSection />
        </div>
    </Flex>
);
